import { createSlice, createAction } from '@reduxjs/toolkit';

import { fetchCarHouseVehicles } from '../actions/carHouseVehicles-actions';

export const setCurrentPage = createAction('carHouseVehicles/setCurrentPage');
export const setSearchParams = createAction('vehicle/setSearchParams');
export const setSortBy = createAction('vehicle/setSortBy');

const initialState = {
  isLoading: false,
  carHouseVehicles: [],
  count: 0,
  currentPage: 1,
  perPage: 1,
};

const carHouseVehiclesSlice = createSlice({
  name: 'carHouseVehicles',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchCarHouseVehicles.pending, (state) => {
        state.isLoadingVehicles = true;
      })
      .addCase(fetchCarHouseVehicles.fulfilled, (state, action) => {
        const { vehicles, count, page } = action.payload;
        state.isLoadingVehicles = false;
        state.carHouseVehicles = vehicles;
        state.count = count;
      })
      .addCase(fetchCarHouseVehicles.rejected, (state) => {
        state.isLoadingVehicles = false;
      })
      .addCase(setCurrentPage, (state, action) => {
        state.currentPage = action.payload; // Update the current page
      })
      .addCase(setSearchParams, (state, action) => {
        state.searchParams = action.payload; // Update the search parameters
      })
      .addCase(setSortBy, (state, action) => {
        state.sortBy = action.payload;
      });
  },
});

export const carHouseVehiclesActions = {
  ...carHouseVehiclesSlice.actions,
  setCurrentPage,
  setSearchParams,
  setSortBy,
};

export default carHouseVehiclesSlice;
